/** English geometry prompts and classification vocabulary (ADR 0051 part 3). */
export const geometryPrompts = {
    classifyAngle: (measure: number) =>
        `An angle measures ${measure}°. Is it acute, right, obtuse or straight?`,
    missingAngleTriangle: (a: number, b: number) =>
        `Two angles of a triangle measure ${a}° and ${b}°. What is the third angle?`,
    missingAngleLine: (a: number) =>
        `Two angles sit on a straight line. One measures ${a}°. What is the other?`,
    missingAnglePoint: (a: number, b: number) =>
        `Three angles meet at a point. Two measure ${a}° and ${b}°. What is the third?`,
    complement: (given: number) => `What is the complement of ${given}°?`,
    supplement: (given: number) => `What is the supplement of ${given}°?`,
    classifyTriangle: (a: number, b: number, c: number) =>
        `A triangle has sides of ${a} cm, ${b} cm and ${c} cm. Is it scalene, isosceles or equilateral?`,
    polygonSidesFromName: (name: string) => `How many sides does a ${name} have?`,
    polygonNameFromSides: (sides: number) => `What is the name for a polygon with ${sides} sides?`,
};

/** The classification answers a person reads. Unchanged from the raw identifiers used internally. */
export const angleClassLabels: Record<'acute' | 'right' | 'obtuse' | 'straight', string> = {
    acute: 'acute',
    right: 'right',
    obtuse: 'obtuse',
    straight: 'straight',
};

export const triangleClassLabels: Record<'equilateral' | 'isosceles' | 'scalene', string> = {
    equilateral: 'equilateral',
    isosceles: 'isosceles',
    scalene: 'scalene',
};

/** Polygon names by side count, matching Constants.ts's POLYGONS list. */
export const polygonNames: Record<number, string> = {
    3: 'triangle',
    4: 'quadrilateral',
    5: 'pentagon',
    6: 'hexagon',
    7: 'heptagon',
    8: 'octagon',
    9: 'nonagon',
    10: 'decagon',
};
